import { useContext } from 'react'

import { Grid } from '@material-ui/core'
import { EditContext } from 'Components/Hooks/ContextEdit'
import PictureCardWithZoom from 'Components/UI/Atoms/PictureCard/PictureCardWithZoom'

const Additional = (props) => {
  const { formEdit } = props

  const [edit] = useContext(EditContext)

  const swipes = formEdit.adicionales?.map((item, index) => ({
    id: index,
    img: item,
  }))

  return (
    <div>
      <Grid container alignContent="center" justify="center" spacing={2}>
        {formEdit.adicionales?.map((item, index) => (
          <Grid item xs={12} xl={4} sm={6} md={4}>
            <PictureCardWithZoom
              img={item}
              edit={edit}
              txt={`Adicional ${index + 1}`}
              title={`Adicional ${index + 1}`}
              index={index + 1}
              swipes={swipes}
              editDelete={false}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  )
}

export default Additional
